/** Recherche plein-texte client de la vue Tâches. Pur, testé. */

/** Minuscules + suppression des diacritiques (NFD). */
export function normalizeSearch(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** Requête vide → true. Sinon : sous-chaîne dans titre OU description. */
export function matchesTaskSearch(
  task: { content: string; description: string | null },
  query: string,
): boolean {
  const q = normalizeSearch(query.trim());
  if (!q) return true;
  if (normalizeSearch(task.content).includes(q)) return true;
  return task.description ? normalizeSearch(task.description).includes(q) : false;
}
